export default class ClubRegistrationModel {
    constructor() {
        this['club.id'] = 0;
        this['club.serialNumber'] = '';
        this['club.registeredName'] = '';
        this.adminStreetName = '';
        this.adminHouseNumber = '';
        this.adminPostalCode = '';
        this.adminCityName = '';
        this['adminCountry.id'] = 0;
        this['adminCountry.description'] = '';
        this.adminIsMainStadium = false;
        this.mainStadiumStreetName = '';
        this.mainStadiumHouseNumber = '';
        this.mainStadiumPostalCode = '';
        this.mainStadiumCityName = '';
        this['mainStadiumCountry.id'] = 0;
        this['mainStadiumCountry.description'] = '';
        this.secondStadium = false;
        this.secondStadiumStreetName = '';
        this.secondStadiumHouseNumber = '';
        this.secondStadiumPostalCode = '';
        this.secondStadiumCityName = '';
        this['secondStadiumCountry.id'] = 0;
        this['secondStadiumCountry.description'] = '';
        //user part
        this.adminUserCode = '';
        this.adminEmail = '';
        this.adminPhoneNumber = '';
        this.adminName = '';
        this.adminFirstName = '';
        this['adminLanguage.id'] = 0;
        this['adminLanguage.name'] = '';
        this.adminUserSystemId = ''

        this.clubCategoryCode = 'Amateur';
        this.clubCategory = 0;
        this.clubCommitmentCode = 1;
        this.clubCommitment = 0;
        // teams 
        this.monoMulti = true;
        this.monoTeamId = '';
        this.numberOfTeams = 2;
        this.team1Id = '';
        this.team2Id = '';
        this.team3Id = '';
        this.team4Id = '';
        this.team5Id = '';
        this.team6Id = '';
        this.team7Id = '';
        this.team8Id = '';
        this.team9Id = '';
        this.team10Id = '';
        this.team11Id = '';
        this.team12Id = '';
        this.team13Id = '';
        this.team14Id = '';
        this.team15Id = '';
        this.team16Id = '';
        this.team17Id = '';
        this.team18Id = '';
        this.team19Id = '';
        this.team20Id = '';
        this.team21Id = '';
        this.team22Id = '';
        this.team23Id = '';
        this.team24Id = '';
        this.team25Id = '';
        this.team26Id = '';
        this.team27Id = '';
        this.team28Id = '';
        this.team29Id = '';
        this.team30Id = '';
        this.team31Id = '';
        this.team32Id = '';
        this.team33Id = '';
        this.team34Id = '';
        this.team35Id = '';
        this.team36Id = '';
        this.team37Id = '';
        this.team38Id = '';
        this.team39Id = '';
        this.team40Id = '';

        this.sportSeasonFreeNarrative = '';
        this.sportSeasonFromDate = '';
        this.sportSeasonToDate = '';
        this.firstMonthInYear = 1;
        this.validated = false;
        this.rejectReason = '';
        this.rejected = false;
        this.status = '';
        this.creationDateTime = '';
        this['clubSeason.clubSeasonId'] = 0;
        this['clubSeason.freeNarrative'] = '';

    }

    setAdminData(clubId, clubSerialNumber, clubRegisteredName, adminStreetName, adminHouseNumber, adminPostalCode, adminIsMainStadium, adminCityName, adminCountryId, adminCountryDescription) {
        this['club.id'] = clubId;
        this['club.serialNumber'] = clubSerialNumber;
        this['club.registeredName'] = clubRegisteredName;
        this.adminStreetName = adminStreetName;
        this.adminHouseNumber = adminHouseNumber;
        this.adminPostalCode = adminPostalCode;
        this.adminCityName = adminCityName;
        this['adminCountry.id'] = adminCountryId;
        this['adminCountry.description'] = adminCountryDescription;
        this.adminIsMainStadium = adminIsMainStadium;
    }
    setMainStadiumData(mainStadiumStreetName, mainStadiumHouseNumber, mainStadiumPostalCode, mainStadiumCityName, mainStadiumCountryId, mainStadiumCountryDescription, secondStadium) {
        this.mainStadiumStreetName = mainStadiumStreetName;
        this.mainStadiumHouseNumber = mainStadiumHouseNumber;
        this.mainStadiumPostalCode = mainStadiumPostalCode;
        this.mainStadiumCityName = mainStadiumCityName;
        this['mainStadiumCountry.id'] = mainStadiumCountryId;
        this['mainStadiumCountry.description'] = mainStadiumCountryDescription;
        this.secondStadium = secondStadium;
    }
    setSecondStadiumData(secondStadiumStreetName, secondStadiumHouseNumber, secondStadiumPostalCode, secondStadiumCityName, secondStadiumCountryId, secondStadiumCountryDescription) {
        this.secondStadiumStreetName = secondStadiumStreetName
        this.secondStadiumHouseNumber = secondStadiumHouseNumber
        this.secondStadiumPostalCode = secondStadiumPostalCode
        this.secondStadiumCityName = secondStadiumCityName
        this['secondStadiumCountry.id'] = secondStadiumCountryId;
        this['secondStadiumCountry.description'] = secondStadiumCountryDescription;
    }

    firstStageValidity() {
        let adminData = [
            this['club.id'],
            this.adminStreetName,
            this.adminHouseNumber,
            this.adminPostalCode,
            this.adminCityName,
            this['adminCountry.id']
        ]
        let mainStadiumData = [
            this.mainStadiumStreetName,
            this.mainStadiumHouseNumber,
            this.mainStadiumPostalCode,
            this.mainStadiumCityName,
            this['mainStadiumCountry.id']
        ]
        let secondStadiumData = [
            this.secondStadiumStreetName,
            this.secondStadiumHouseNumber,
            this.secondStadiumPostalCode,
            this.secondStadiumCityName,
            this['secondStadiumCountry.id']
        ]
        let arrayForValidation = []
        arrayForValidation = arrayForValidation.concat(adminData)

        if (this.adminIsMainStadium) {
            arrayForValidation = adminData.concat(mainStadiumData)
        }
        if (this.secondStadium) {
            arrayForValidation = arrayForValidation.concat(secondStadiumData)
        }
        let notValid = [];
        for (let i = 0; i < arrayForValidation.length; i++) {
            if (arrayForValidation[i] === '' || arrayForValidation[i] === 0 || arrayForValidation[i] === null || arrayForValidation[i].id && arrayForValidation[i].id === 0) {
                notValid.push(arrayForValidation[i])
            }
        }
        return notValid.length === 0
    }
    setUserData(adminUserCode, adminEmail, adminPhoneNumber, adminName, adminFirstName, adminLanguageId, adminLanguageName, adminUserSystemId) {
        this.adminUserCode = adminUserCode
        this.adminEmail = adminEmail
        this.adminPhoneNumber = adminPhoneNumber
        this.adminName = adminName
        this.adminFirstName = adminFirstName
        this['adminLanguage.id'] = adminLanguageId;
        this['adminLanguage.name'] = adminLanguageName
        this.adminUserSystemId = adminUserSystemId
    }
    isValid(filedsArray) {
        let notValid = [];
        for (let i = 0; i < filedsArray.length; i++) {
            if (filedsArray[i] === '' || filedsArray[i] === 0 || filedsArray[i] === null || filedsArray[i].id && filedsArray[i].id === 0) {
                notValid.push(filedsArray[i])
            }
        }
        return notValid.length === 0
    }
    setThirdStadiumData(
        clubCategoryCode,
        clubCommitmentCode,
        monoMulti,
        monoTeamId,
        numberOfTeams,
        team1Id,
        team2Id,
        team3Id,
        team4Id,
        team5Id,
        team6Id,
        team7Id,
        team8Id,
        team9Id,
        team10Id,
        team11Id,
        team12Id,
        team13Id,
        team14Id,
        team15Id,
        team16Id,
        team17Id,
        team18Id,
        team19Id,
        team20Id,
        team21Id,
        team22Id,
        team23Id,
        team24Id,
        team25Id,
        team26Id,
        team27Id,
        team28Id,
        team29Id,
        team30Id,
        team31Id,
        team32Id,
        team33Id,
        team34Id,
        team35Id,
        team36Id,
        team37Id,
        team38Id,
        team39Id,
        team40Id
    ) {
        this.clubCategoryCode = clubCategoryCode;
        this.clubCommitmentCode = clubCommitmentCode;
        // teams 
        this.monoMulti = monoMulti;
        if (monoMulti) {
            this.monoTeamId = monoTeamId;
            this.numberOfTeams = 0;
            this.team1Id = '';
            this.team2Id = '';
            this.team3Id = '';
            this.team4Id = '';
            this.team5Id = '';
            this.team6Id = '';
            this.team7Id = '';
            this.team8Id = '';
            this.team9Id = '';
            this.team10Id = '';
            this.team11Id = '';
            this.team12Id = '';
            this.team13Id = '';
            this.team14Id = '';
            this.team15Id = '';
            this.team16Id = '';
            this.team17Id = '';
            this.team18Id = '';
            this.team19Id = '';
            this.team20Id = '';
            this.team21Id = '';
            this.team22Id = '';
            this.team23Id = '';
            this.team24Id = '';
            this.team25Id = '';
            this.team26Id = '';
            this.team27Id = '';
            this.team28Id = '';
            this.team29Id = '';
            this.team30Id = '';
            this.team31Id = '';
            this.team32Id = '';
            this.team33Id = '';
            this.team34Id = '';
            this.team35Id = '';
            this.team36Id = '';
            this.team37Id = '';
            this.team38Id = '';
            this.team39Id = '';
            this.team40Id = '';
        } else {
            this.monoTeamId = '';
            this.numberOfTeams = numberOfTeams;
            this.team1Id = team1Id;
            this.team2Id = team2Id;
            this.team3Id = team3Id;
            this.team4Id = team4Id;
            this.team5Id = team5Id;
            this.team6Id = team6Id;
            this.team7Id = team7Id;
            this.team8Id = team8Id;
            this.team9Id = team9Id;
            this.team10Id = team10Id;
            this.team11Id = team11Id;
            this.team12Id = team12Id;
            this.team13Id = team13Id;
            this.team14Id = team14Id;
            this.team15Id = team15Id;
            this.team16Id = team16Id;
            this.team17Id = team17Id;
            this.team18Id = team18Id;
            this.team19Id = team19Id;
            this.team20Id = team20Id;
            this.team21Id = team21Id;
            this.team22Id = team22Id;
            this.team23Id = team23Id;
            this.team24Id = team24Id;
            this.team25Id = team25Id;
            this.team26Id = team26Id;
            this.team27Id = team27Id;
            this.team28Id = team28Id;
            this.team29Id = team29Id;
            this.team30Id = team30Id;
            this.team31Id = team31Id;
            this.team32Id = team32Id;
            this.team33Id = team33Id;
            this.team34Id = team34Id;
            this.team35Id = team35Id;
            this.team36Id = team36Id;
            this.team37Id = team37Id;
            this.team38Id = team38Id;
            this.team39Id = team39Id;
            this.team40Id = team40Id;
        }
    }
    thirdStageValidity() {
        let fieldsArray = [this.clubCategoryCode, this.clubCommitmentCode];
        if (this.monoMulti) {
            fieldsArray.push(this.monoTeamId);
        } else {
            let i = 1,
                filedName = '';
            for (i; i <= this.numberOfTeams; i++) {
                filedName = 'team' + i + 'Id'
                fieldsArray.push(this[filedName])
            }
        }
        return this.isValid(fieldsArray);
    }
    setFourthStadiumData(clubSeasonId, freeNarrative = '') {
        // this.sportSeasonFreeNarrative = sportSeasonFreeNarrative;
        // this.sportSeasonFromDate = sportSeasonFromDate;
        // this.sportSeasonToDate = sportSeasonToDate;
        // this.firstMonthInYear = firstMonthInYear;
        this['clubSeason.clubSeasonId'] = clubSeasonId;
        this['clubSeason.freeNarrative'] = freeNarrative;

    }
}



// WEBPACK FOOTER //
// ./src/main/resources/js/components/RegistrationFormComponents/ClubRegistrationModel.js